import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useToken } from "../auth/useToken";
import { Box, TextField, Button } from "@mui/material";
import { SERVER_URL } from "../app/constant";
import jwt_decode from "jwt-decode";

export const SignUpPage = () => {
  const [token, setToken] = useToken();
  const [errorMessage, setErrorMessage] = useState("");

  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [confirmPasswordValue, setConfirmPasswordValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const history = useHistory();

  const onSignUpClicked = async () => {
    setIsSubmitting(true);
    setErrorMessage("");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: emailValue,
        password: passwordValue,
      }),
    };

    try {
      const response = await fetch(`${SERVER_URL}/signup`, requestOptions);
      if (!response.ok) {
        throw new Error("We couldn't create your account. Please try again.");
      }
      const data = await response.json();
      setToken(data.token);
      history.push(`/please-verify?email=${encodeURIComponent(emailValue)}`);
    } catch (e) {
      setErrorMessage(e.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  function handleCallbackResponse(response) {
    console.log("Encoded JWT ID token: " + response.credential);
    var userObject = jwt_decode(response.credential);
    console.log(userObject);
  }

  useEffect(() => {
    /* global google */
    google.accounts.id.initialize({
      client_id: "949161531967-g19rrq89h0eur9a7ni9nkvuk2sj069rc.apps.googleusercontent.com",
      callback: handleCallbackResponse
    });

    google.accounts.id.renderButton(
      document.getElementById("signUpDiv"),
      { theme: "outline", size: "large", width: "300px", mt: 3 }
    );
  }, []);

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1 style={{ color: "#3366BB" }}>Sign Up</h1>
      {errorMessage && <div className="fail" role="alert">{errorMessage}</div>}
      <TextField
        sx={{ width: "300px", mt: 2 }}
        id="signup-email"
        value={emailValue}
        label="Email"
        type="email"
        autoComplete="email"
        onChange={(e) => setEmailValue(e.target.value)}
      />
      <TextField
        sx={{ width: "300px", mt: 2 }}
        type="password"
        value={passwordValue}
        id="signup-password"
        label="Password"
        onChange={(e) => setPasswordValue(e.target.value)}
        placeholder="password"
      />
      <TextField
        sx={{ width: "300px", mt: 2 }}
        type="password"
        id="signup-confirm-password"
        label="Confirm Password"
        value={confirmPasswordValue}
        onChange={(e) => setConfirmPasswordValue(e.target.value)}
        error={passwordValue !== confirmPasswordValue}
        helperText={
          passwordValue !== confirmPasswordValue ? "Passwords do not match" : " "
        }
      />
      <hr />
      <Button
        variant="contained"
        sx={{ width: "300px", mt: 2 }}
        disabled={
          !emailValue ||
          !passwordValue ||
          passwordValue !== confirmPasswordValue ||
          isSubmitting
        }
        onClick={onSignUpClicked}
      >
        {isSubmitting ? "Signing up..." : "Sign Up"}
      </Button>
      <p style={{ color: "#3366BB" }}>OR</p>
      {<div id="signUpDiv"></div>}
      <Button sx={{ mt: 2 }} onClick={() => history.push("/login")}>
        Already have an account? Log In
      </Button>
    </Box>
  );
};
